/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const MegaphoneSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.7872 21.1197C12.8687 21.0404 11.9391 21 11 21H10C6.68629 21 4 18.3137 4 15C4 11.6863 6.68629 9 10 9H11C11.9391 9 12.8687 8.95955 13.7872 8.88029M13.7872 21.1197C14.1244 22.402 14.565 23.6423 15.0995 24.8312C15.4295 25.5651 15.179 26.4437 14.4821 26.846L13.6071 27.3512C12.8719 27.7757 11.9275 27.5074 11.5712 26.7369C10.7357 24.9298 10.0872 23.0185 9.65047 21.0279M13.7872 21.1197C13.2736 19.166 13 17.1149 13 15C13 12.885 13.2736 10.834 13.7872 8.88029M13.7872 21.1197C18 21.4832 21.9793 22.6629 25.5663 24.4999M13.7872 8.88029C18 8.5168 21.9793 7.3371 25.5663 5.50012M26.9181 12.6932C26.741 10.2062 26.2796 7.7977 25.5663 5.50012C25.4094 4.99459 25.2402 4.49444 25.0592 4M25.5663 24.4999C25.4094 25.0054 25.2402 25.5056 25.0592 26M26.9181 12.6932C26.9724 13.4551 27 14.2243 27 15C27 15.7757 26.9724 16.5449 26.9181 17.3068C26.741 19.7938 26.2796 22.2023 25.5663 24.4999M26.9181 12.6932C27.5792 13.2435 28 14.0726 28 15C28 15.9274 27.5792 16.7565 26.9181 17.3068"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default MegaphoneSvg
